import React from "react";
import "./FormWrapper.css";

const FormWrapper = props => (
  <div className={"form-wrapper " + props.class}>{props.children}</div>
);

export default FormWrapper;



// WEBPACK FOOTER //
// ./src/system/components/FormWrapper/index.jsx